import React from "react";
import { MotionConfig, motion } from "framer-motion";

interface ButtonProps {
  isOpen: boolean;
  setIsOpen: React.Dispatch<React.SetStateAction<boolean>>;
  setActive: React.Dispatch<React.SetStateAction<boolean>>;
}

export const SidebarButton: React.FC<ButtonProps> = ({ isOpen, setIsOpen, setActive }) => {
  return (
    <div className="grid h-fit w-fit place-content-center bg-accent rounded-md">
      <AnimatedHamburgerButton isOpen={isOpen} setIsOpen={setIsOpen} setActive={setActive} />
    </div>
  );
};

const AnimatedHamburgerButton: React.FC<ButtonProps> = ({ isOpen, setIsOpen, setActive }) => {
  const handleClick = () => {
    setIsOpen((prevIsOpen) => !prevIsOpen);
    setActive((prevActive) => !prevActive);
  };

  return (
    <MotionConfig
      transition={{
        duration: 0.5,
        ease: "easeInOut",
      }}
    >
      <motion.button
        initial={false}
        animate={isOpen ? "open" : "closed"}
        onClick={handleClick}
        className="relative h-10 w-10 rounded-full bg-white/0 transition-colors hover:bg-white/20"
        aria-label={isOpen ? "Close sidebar" : "Open sidebar"}
      >
        <motion.span
          variants={VARIANTS.top}
          className="absolute h-[3px] w-6 bg-black"
          style={{ y: "-50%", left: "50%", x: "-50%", top: "35%" }}
        />
        <motion.span
          variants={VARIANTS.middle}
          className="absolute h-[3px] w-6 bg-black"
          style={{ left: "50%", x: "-50%", top: "50%", y: "-50%" }}
        />
        <motion.span
          variants={VARIANTS.bottom}
          className="absolute h-[3px] w-5 bg-black"
          style={{
            x: "-50%",
            y: "50%",
            bottom: "35%",
            left: "calc(50% + 10px)",
          }}
        />
      </motion.button>
    </MotionConfig>
  );
};

const VARIANTS = {
  top: {
    open: {
      rotate: ["0deg", "0deg", "45deg"],
      top: ["35%", "50%", "50%"],
    },
    closed: {
      rotate: ["45deg", "0deg", "0deg"],
      top: ["50%", "50%", "35%"],
    },
  },
  middle: {
    open: {
      rotate: ["0deg", "0deg", "-45deg"],
    },
    closed: {
      rotate: ["-45deg", "0deg", "0deg"],
    },
  },
  bottom: {
    open: {
      rotate: ["0deg", "0deg", "45deg"],
      bottom: ["35%", "50%", "50%"],
      left: "50%",
    },
    closed: {
      rotate: ["45deg", "0deg", "0deg"],
      bottom: ["50%", "50%", "35%"],
      left: "calc(50% + 2px)",
    },
  },
};
